var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { IMaskMixin } from 'react-imask';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { CONST_EINHEITEN, InputMaskType } from '../../../../../classes/learnware/LearnwareEnums';
import { RareInputMaskRender } from './RareInputMaskRender';
import { helper_array_ofLength } from '../../../../../utils/helper/helper_array';
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
import { runtime } from '../../../../../classes/runtime/Runtime';
let RareInputMask = class RareInputMask extends React.PureComponent {
    get inputMask() {
        const { wordTask } = this.props.aspect.context;
        const firstWording = wordTask.wordings.length > 0 && wordTask.wordings[0].wordingString || '';
        const inputMask = wordTask.wordTaskMask.activeInputMask;
        if (inputMask === InputMaskType.Integer) {
            return { mask: createNumberMask({
                    thousandsSeparatorSymbol: ' ',
                    suffix: '',
                    prefix: '',
                }),
                placeholderChar: undefined, guide: false };
        }
        if (inputMask === InputMaskType.TimeX_XX)
            return { mask: [/[1-9]/, ':', /[0-9]/, /[0-9]/] }; // e.g. Question 370710 (Trage Uhrzeiten ein)
        if (inputMask === InputMaskType.TimeXX_XX)
            return { mask: [/[1-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/] }; // e.g. Question 370710 (Trage Uhrzeiten ein)
        if (inputMask === InputMaskType.Uhrzeit) {
            const hours = firstWording.split('.')[0];
            return { mask: [...(hours.length === 1 ? [/[1-9]/] : [/[1-2]/, hours[0] === '2' ? /[0-4]/ : /[0-9]/]), '.', /[0-5]/, /[0-9]/, ' ', 'U', 'h', 'r'] };
        }
        if (inputMask === InputMaskType.Decimal) {
            return { mask: createNumberMask({
                    thousandsSeparatorSymbol: ' ',
                    suffix: '',
                    prefix: '',
                    allowDecimal: true,
                    decimalSymbol: ',',
                    requireDecimal: true,
                }), guide: false };
        }
        if (inputMask === InputMaskType.NumberPrefixSuffix) {
            const suffix = wordTask.ownAspect.maskSuffix.text && wordTask.ownAspect.maskSuffix.text.textOutputString || '';
            const prefix = wordTask.ownAspect.maskPrefix.text && wordTask.ownAspect.maskPrefix.text.textOutputString || '';
            return { mask: createNumberMask({
                    thousandsSeparatorSymbol: ' ',
                    suffix,
                    prefix,
                }) };
        }
        if (inputMask === InputMaskType.Decimal1x1)
            return { mask: [/[0-9]/, ',', /[0-9]/] }; // e.g. Question 370710 (Trage Uhrzeiten ein)
        if (inputMask === InputMaskType.Decimal1x2)
            return { mask: [/[0-9]/, ',', /[0-9]/, /[0-9]/] };
        if (inputMask === InputMaskType.Addition3x1E2)
            return { mask: [/[0-9]/, ' ', '+', ' ', /[0-9]/, ' ', '+', ' ', /[0-9]/, ' ', '=', ' ', /[0-9]/, /[0-9]/] };
        if (inputMask === InputMaskType.Addition3x1E1)
            return { mask: [/[0-9]/, ' ', '+', ' ', /[0-9]/, ' ', '+', ' ', /[0-9]/, ' ', '=', ' ', /[0-9]/] };
        if (inputMask === InputMaskType.Addition3P2P1)
            return { mask: [/[0-9]/, /[0-9]/, /[0-9]/, ' ', '+', ' ', /[0-9]/, /[0-9]/, ' ', '+', ' ', /[0-9]/] };
        if (inputMask === InputMaskType.EuroCent)
            return { mask: [...(helper_array_ofLength(firstWording.split('€')[0].length).map(n => /[0-9]/)), ' ', '€', ' ', ...(helper_array_ofLength(firstWording.split('€ ')[1].split('ct')[0].length).map(n => /[0-9]/)), ' ', 'c', 't'] };
        if (inputMask === InputMaskType.Einheit) {
            const passendeEinheit = CONST_EINHEITEN.find(einheit => firstWording.endsWith(einheit));
            if (passendeEinheit) {
                const lengthInFrontOfComma = firstWording.split(passendeEinheit)[0].split(',')[0].length;
                const lengthAfterComma = firstWording.includes(',') && firstWording.split(passendeEinheit)[0].split(',')[1].length || 0;
                return [...(helper_array_ofLength(lengthInFrontOfComma).map(n => /[0-9]/)), ...(firstWording.includes(',') ? [',', ...(helper_array_ofLength(lengthAfterComma).map(n => /[0-9]/))] : []), ' ', ...Array.from(passendeEinheit)];
            }
        }
        return undefined;
    }
    get imask() {
        const { wordTask } = this.props.aspect.context;
        const firstWording = wordTask.wordings.length > 0 && wordTask.wordings[0].wordingString || '';
        const inputMask = wordTask.wordTaskMask.activeInputMask;
        if (inputMask === InputMaskType.Einheit) {
            //  if(runtime.browserRuntime && !runtime.browserRuntime.browserAgent.isSafari) return undefined;
            const passendeEinheit = CONST_EINHEITEN.find(einheit => firstWording.endsWith(einheit));
            if (passendeEinheit) {
                const lengthInFrontOfComma = firstWording.split(passendeEinheit)[0].split(',')[0].length;
                const lengthAfterComma = firstWording.includes(',') && firstWording.split(passendeEinheit)[0].split(',')[1].length || 0;
                const beforeComma = helper_array_ofLength(lengthInFrontOfComma).map(n => 0).join('');
                const afterComma = firstWording.includes(',') ? `,${helper_array_ofLength(lengthAfterComma).map(n => 0).join('')}` : '';
                return { mask: `${beforeComma}${afterComma} ${passendeEinheit}` };
            }
        }
        return undefined;
    }
    render() {
        if (this.imask)
            return this.iMaskComponent;
        return this.textMaskComponent;
    }
    get CustomIMask() {
        return IMaskMixin(({ inputRef, ...props }) => {
            const refWrapper = (e) => {
                runtime.runtimeScheduler.scheduleForAnimationFrame(() => props.aspect.aspectMount.setDomNode(e));
                inputRef(e);
            };
            return React.createElement("input", { key: props.aspect.tid, ...props.jsxAttributes, onKeyUp: () => { }, ref: refWrapper });
        });
    }
    get iMaskComponent() {
        const { aspect, jsxAttributes } = this.props;
        const CustomIMask = this.CustomIMask;
        return (React.createElement(CustomIMask, { key: aspect.tid, jsxAttributes: jsxAttributes, aspect: aspect, overwrite: true, lazy: false, value: jsxAttributes.value, autofix: true, onAccept: (value, mask) => {
                if (!jsxAttributes.onChange)
                    return;
                const e = { type: 'change' };
                e.target = { value };
                if (aspect.context.memorizePointsWordTask && !aspect.context.questionMemorizePoints.isOrdered) {
                    //   aspect.context.questionMemorizePoints.memorizePointsUnordered.assignChangeEventToBestMatching(e);
                    return;
                }
                jsxAttributes.onChange(e);
            }, ...this.imask }));
    }
    get textMaskComponent() {
        const { aspect, jsxAttributes } = this.props;
        return (React.createElement(MaskedInput, { key: aspect.tid, guide: true, onChange: e => {
                if (!jsxAttributes.onChange)
                    return;
                jsxAttributes.onChange(e);
            }, onBlur: jsxAttributes.onBlur, placeholderChar: '_', keepCharPositions: true, showMask: true, render: (ref, renderProps) => (React.createElement(RareInputMaskRender, { renderProps: renderProps, renderRef: ref, aspect: aspect, jsxAttributes: jsxAttributes })), value: jsxAttributes.value, mask: [/\d/], ...this.inputMask })
        //   mask={[ /\d/]} is fallback mask
        );
    }
    get aspectMount() {
        return this.props.aspect.aspectMounts.getMountForComponent(this);
    }
    componentDidMount() {
        this.props.aspect.aspectMounts.mountAspect(this);
    }
    componentDidUpdate(prevProps) {
        if (this.props.aspect !== prevProps.aspect) {
            prevProps.aspect.aspectMounts.unMountAspect(this);
            this.props.aspect.aspectMounts.mountAspect(this);
        }
    }
    componentWillUnmount() {
        this.props.aspect.aspectMounts.unMountAspect(this);
        if (this.props.aspect.aspectMount.measureDom.lastResizeObserver) {
            this.props.aspect.aspectMount.measureDom.lastResizeObserver.disconnect();
        }
        if (this.props.aspect.aspectMount.measureDom.lastMutationObserver) {
            this.props.aspect.aspectMount.measureDom.lastMutationObserver.disconnect();
        }
    }
};
__decorate([
    computed
], RareInputMask.prototype, "inputMask", null);
__decorate([
    computed
], RareInputMask.prototype, "imask", null);
__decorate([
    memoize
], RareInputMask.prototype, "CustomIMask", null);
__decorate([
    computed
], RareInputMask.prototype, "iMaskComponent", null);
RareInputMask = __decorate([
    observer
], RareInputMask);
export { RareInputMask };
